var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"wrap"},[_c('v-flex',{staticClass:"xs12 clickable h4 mb-0",on:{"click":function($event){$event.preventDefault();return _vm.toggleMenu()}}},[_c('span',{staticClass:"fal fa-bars ml-2"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }